import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import OrganizerSocial from './organizer-social'
import LinkButton from '../../../system/forms/link-button'
import Icon, { IconType } from '../../../system/icons'
import breakpoints from '../../../../styles/breakpoints'
import IconButton from '../../../system/forms/icon-button'
import { useEvent } from '../../event-details'
import { bumpRichTextHeading } from '../../../../utils/rich-text-utils'
import SidebarSectionLabel from '../sidebar-section-label'

const ExpandOrganizerButton = styled(LinkButton)`
  display: flex;
  align-items: center;
  margin-top: ${props => props.theme.spacing.base500};

  span {
    margin-right: ${props => props.theme.spacing.base200};
  }

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }

  ${({ expanded }: { expanded: boolean }) =>
    expanded &&
    css`
      display: none;
    `}
`

const StyledAboutOrganizer = styled.section`
  display: none;

  ${({ expanded }: { expanded: boolean }) =>
    expanded &&
    css`
      display: block;
    `}

  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`

const CollapseOrganizerIcon = styled(IconButton)`
  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`

const Heading = styled(SidebarSectionLabel)`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  transition: color 100ms ease;

  @media (max-width: ${breakpoints.md}) {
    cursor: pointer;
    &:hover {
      color: ${props => props.theme.colors.linkHoverColor};
    }
  }
`

const AboutOrganizer = () => {
  const event = useEvent()
  if (!event) return null
  const organizer = event.organizer

  const hasSocial =
    organizer.twitter || organizer.facebook || organizer.instagram || organizer.website
  const hasAboutTheOrganizer = organizer.description || hasSocial

  if (!hasAboutTheOrganizer) {
    return null
  }

  const headingBumpedOrganizerDescription = organizer.description
    ? bumpRichTextHeading(3, organizer.description)
    : null

  const [organizerExpanded, setOrganizerExpanded] = useState(true)

  return (
    <section>
      <ExpandOrganizerButton
        aria-expanded="false"
        onClick={() => setOrganizerExpanded(!organizerExpanded)}
        expanded={organizerExpanded}
        aria-label="Toggle about the organizer section"
      >
        <span>About the organizer</span>
        <Icon type={IconType.ExpandDown} />
      </ExpandOrganizerButton>

      <StyledAboutOrganizer expanded={organizerExpanded}>
        <Heading aria-expanded={organizerExpanded} onClick={() => setOrganizerExpanded(false)}>
          About the organizer
          <CollapseOrganizerIcon
            icon={IconType.ExpandUp}
            aria-label="Toggle about the organizer section"
          />
        </Heading>
        {headingBumpedOrganizerDescription &&
          documentToReactComponents(headingBumpedOrganizerDescription)}

        {hasSocial && <OrganizerSocial />}
      </StyledAboutOrganizer>
    </section>
  )
}

export default AboutOrganizer
